import Dynamic from 'next/dynamic';
import * as SignUpOnboarding from './SignUpOnboarding.bs';

const register = Dynamic(() => Promise.resolve(SignUpOnboarding.make), {
  ssr: false,
});

const $$default = register;
export { $$default, $$default as default };
